<template>
  <div class="float_card">
    <div class="card_title">
      <span>{{getLangMsg("intvTaskCale_intv_data")}}</span><span class="card_close" @click="closePop"></span>
    </div>
    <div class="card_body">
      <div class="card_body_box">
        <div class="card_body_item" :class="{'card_body_item_new':new Date(itemTaskDef.endTimeLong) > new Date()}"
             v-for="(itemTaskDef,indexTaskDef) in taskList">
          <div class="left_icon">
            <div class="kdfont kdfont-jianchatongguo" v-if="new Date(itemTaskDef.endTimeLong) < new Date()"></div>
            <div class="kdfont kdfont-jinxingzhong" style="color: #FF991C" v-else></div>
            <div class="guide_line" v-if="indexTaskDef !== (taskList.length-1)"></div>
          </div>
          <div class="right_box" @click="toTaskDetail(itemTaskDef.taskId)">
            <div class="title_state">
              <div class="title" :title="itemTaskDef.intvTitle">{{ itemTaskDef.intvTitle }}</div>
            </div>
            <div class="intv_time">
              <div class="colorGray">{{getLangMsg("intvTaskCale_intv_time")}}</div>
              <div class="colorBlack">
                {{ itemTaskDef.startTimeLong | formatHM }}-{{ itemTaskDef.endTimeLong| formatHM }}
              </div>
            </div>
            <div class="intv_spot" v-show="itemTaskDef.interviewMethodId===1010">
              <div class="colorGray">{{getLangMsg("intvTaskCale_intv_place")}}</div>
              <div class="colorBlack" :title="itemTaskDef.intvAddress">{{ itemTaskDef.intvAddress }}</div>
            </div>
            <div class="intv_room" v-show="itemTaskDef.interviewMethodId===1010 && itemTaskDef.intvRoom !== ''">
              <div class="colorGray">{{getLangMsg("intvTaskCale_intv_room")}}</div>
              <div class="colorBlack" :title="itemTaskDef.intvRoom">{{ itemTaskDef.intvRoom }}</div>
            </div>
            <div class="intv_videourl" v-show="itemTaskDef.interviewMethodId===1040">
              <div class="colorGray">{{getLangMsg("intvTaskCale_intv_place")}}</div>
              <a class="colorBlack" :href="itemTaskDef.intvAddress" target="_blank" @click.stop="">{{getLangMsg("intvTaskCale_intv_videoLink")}}</a>
            </div>
            <div class="intv_candidate">
              <div class="colorGray">{{getLangMsg("intvTaskCale_intv_candidate")}}</div>
              <div class="colorBlack"
                   :title="(itemTaskDef.candidates && itemTaskDef.candidates.length>0) ? itemTaskDef.candidates.join(','):''">
                {{ formatCandidates(itemTaskDef.candidates) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {utils} from '../common/common'

export default {
  props: {
    taskList: Array,
    invoke: Function
  },
  filters: {
    formatHM(value) {
      return utils.dateFormat("hh:mm", value);
    }
  },
  data() {
    return {
      intvStateObj: {A: '未完成', B: '已完成', C: '已取消'},
    }
  },
  methods: {
    closePop() {
      document.body.click();
    },
    toTaskDetail(id) {
      this.invoke('turnToTaskList', id)
      this.closePop();
    },
    formatCandidates(value) {
      if (value && value.length > 0) {
        if (value.length > 3) {
          return value.slice(0, 2).join(",") + this.getLangMsg("intvTaskCale_key0001",{'text':value.length});
        } else {
          return value.join(",")
        }
      }
      return "";
    },
  }
}
</script>
<style lang="less">
.float_card {
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .card_title {
    display: flex;
    flex-shrink: 0;
    height: 40px;
    font-size: 14px;
    background: #F2F2F2;
    padding: 0 16px;
    justify-content: space-between;
    align-items: center;

    .card_close {
      cursor: pointer;
      font-family: kdfont !important;
      font-size: 16px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;

      &::before {
        content: "\e6b6";
      }
    }
  }

  .card_body {
    font-size: 12px;
    margin: 16px 0 8px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .card_body_box {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      max-height: 516px;
      overflow-y: auto;
    }

    .card_body_item {
      display: flex;
      flex-direction: row;
      margin: 0 20px 8px;
      color: #999999;

      .left_icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 12px 10px 0 0;

        .kdfont{
          font-size: 16px;
        }

        .guide_line {
          width: 1px;
          background: #D8D8D8;
          margin-bottom: -18px;
          flex-grow: 1;
        }
      }

      .right_box {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 12px 12px 5px;
        background: #F5F6F8;
        flex-grow: 1;
        border-radius: 2px;
        cursor: pointer;

        &:hover {
          background: #FFF1D4;
        }

        .title_state {
          display: flex;
          flex-direction: row;
          margin-bottom: 6px;

          .title {
            width: 120px;
            flex-grow: 1;
            font-weight: bold;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .intv_candidate, .intv_room, .intv_spot, .intv_time, .intv_videourl {
          display: flex;
          margin-bottom: 3px;
          flex-direction: row;

          :first-child {
            flex-shrink: 0;
          }

          :last-child {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 50px;
            flex-grow: 1;
          }
        }

        .intv_videourl {
          a {
            color: #5582F3;
          }
        }

      }
    }

    .card_body_item_new {
      .title {
        color: #333333;
      }

      .colorBlack {
        color: #666666;
      }
    }
  }
}
</style>